import React from 'react';
interface ValueStackSectionProps {
  onAddToCart?: () => void;
}
export function ValueStackSection({
  onAddToCart
}: ValueStackSectionProps) {
  return <section id="price-box" className="py-16 md:py-24 px-4 bg-cream-dark" data-id="element-441">
      <div className="max-w-3xl mx-auto" data-id="element-442">
        <div className="text-center mb-12" data-id="element-443">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy leading-tight" data-id="element-444">
            Todo lo que recibes hoy
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border-t-4 border-cta p-6 md:p-10" data-id="element-445">
          <div className="space-y-4 mb-8" data-id="element-446">
            <div className="flex justify-between items-center py-3 border-b border-navy/5" data-id="element-447">
              <span className="text-navy font-sans text-lg" data-id="element-448">
                Ebook "El Azúcar Silencioso"
              </span>
              <span className="text-navy/40 line-through font-sans" data-id="element-449">
                $27.00
              </span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-navy/5" data-id="element-450">
              <span className="text-navy font-sans text-lg flex items-center gap-2" data-id="element-451">
                <span data-id="element-452">🎁</span> Bono 1: 56 Disfraces del Azúcar
              </span>
              <span className="text-navy/40 line-through font-sans" data-id="element-453">$9.95</span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-navy/5" data-id="element-454">
              <span className="text-navy font-sans text-lg flex items-center gap-2" data-id="element-455">
                <span data-id="element-456">🎁</span> Bono 2: Mecanismo de Rescate
              </span>
              <span className="text-navy/40 line-through font-sans" data-id="element-457">$9.95</span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-navy/5" data-id="element-458">
              <span className="text-navy font-sans text-lg flex items-center gap-2" data-id="element-459">
                <span data-id="element-460">🎁</span> Bono 3: Menú 7 Días
              </span>
              <span className="text-navy/40 line-through font-sans" data-id="element-461">
                $14.95
              </span>
            </div>
            <div className="flex justify-between items-center py-3" data-id="element-462">
              <span className="text-navy/60 font-sans text-lg font-bold" data-id="element-463">
                Valor total:
              </span>
              <span className="text-navy/40 line-through font-sans font-bold" data-id="element-464">
                $61.85
              </span>
            </div>
          </div>

          <div className="flex justify-center mb-8" data-id="element-465">
            <img src="https://cdn.magicpatterns.com/uploads/sM27ejzFioGAv1VedgNkvd/Imagen_Bundle_Ebook_-_3_Bonos.png" alt="Bundle: Ebook El Azúcar Silencioso + 3 Bonos" className="w-full max-w-sm h-auto rounded-xl shadow-lg" data-id="element-466" />
          </div>

          <div className="bg-cream-dark rounded-xl p-6 md:p-8 text-center mb-8 border border-navy/5" data-id="element-467">
            <p className="text-navy/80 font-sans text-lg mb-2" data-id="element-468">
              Hoy todo por solo
            </p>
            <div className="text-5xl md:text-6xl font-serif font-bold text-cta mb-2" data-id="element-469">
              $17.95
            </div>
            <p className="text-navy font-bold font-sans uppercase tracking-wider text-sm" data-id="element-470">
              Ahorras $43.90
            </p>
          </div>

          <div className="flex flex-col items-center gap-4 mb-8" data-id="element-471">
            <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" className="w-full" onClick={() => onAddToCart?.()} data-id="element-472">
              <button className="w-full bg-cta hover:bg-cta-hover text-white font-bold text-lg md:text-xl py-5 px-8 rounded-lg transition-all duration-300 shadow-[0_4px_14px_0_rgba(200,16,46,0.39)] hover:shadow-[0_6px_20px_rgba(200,16,46,0.23)] hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-473">
                <span data-id="element-474">🔒 DESCARGA EBOOK + 3 BONOS — $17.95</span>
              </button>
            </a>
            <p className="text-xs md:text-sm text-navy/60 font-sans text-center" data-id="element-475">
              Acceso inmediato · 4 PDFs descargables · Tuyos para siempre · Pago
              seguro
            </p>
          </div>

          <div className="bg-navy/5 rounded-lg p-5 flex items-start gap-4" data-id="element-476">
            <span className="text-2xl" data-id="element-477">✅</span>
            <div data-id="element-478">
              <h4 className="font-bold text-navy font-sans mb-1" data-id="element-479">
                Garantía de satisfacción
              </h4>
              <p className="text-sm text-navy/70 font-sans leading-relaxed" data-id="element-480">
                Si no sientes que la información vale más de lo que pagaste, te
                devolvemos tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}